<div class="container-fluid mt-3">
  <mat-card class="p-3 mb-3">
  <h2 class="text-center mb-3">{{ currentEditId ? 'Update Group Session Topics':'Add Group Session Topics' }}</h2>
  <form [formGroup]="groupSessionForm" class="row" autocomplete="off">

    <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
      <mat-label>Serial Number</mat-label>
      <input matInput type="number" formControlName="sr" placeholder="Enter ordering number"/>
      <mat-error
        *ngIf="groupSessionForm.controls.sr?.invalid && (groupSessionForm.controls.sr?.touched || groupSessionForm.controls.sr?.dirty)">
        <mat-error style="color: red;" *ngIf="groupSessionForm.controls.sr?.errors?.required">*It is Required.</mat-error>
        <mat-error style="color: red;" *ngIf="groupSessionForm.controls.sr?.errors?.min">*Minimum value is 1.</mat-error>
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="col-md-4 col-sm-12">
      <mat-label>Topic</mat-label>
      <input matInput formControlName="content"/>
      <mat-error
        *ngIf="groupSessionForm.controls.content?.invalid && (groupSessionForm.controls.content?.touched || groupSessionForm.controls.content?.dirty)">
        <mat-error style="color: red;" *ngIf="groupSessionForm.controls.content?.errors?.required">*It is Required.</mat-error>
        <mat-error style="color: red;" *ngIf="groupSessionForm.controls.content?.errors?.pattern">*Enter Only characters.</mat-error>
      </mat-error>
    </mat-form-field>

    <!-- Detailed Description File (SINGLE FILE) -->
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Detailed Description File</mat-label>
      <ngx-mat-file-input
        placeholder="Select File (Document)"
        (change)="onDetailedDescriptionFileChange($event)"
        accept=".pdf,.doc,.docx,.ppt,.pptx,.txt"
        [disabled]="currentEditId">
      </ngx-mat-file-input>
      <mat-icon matSuffix>folder</mat-icon>
      <mat-hint>Max 25MB. Single document only</mat-hint>
      <mat-error *ngIf="groupSessionForm.get('detailedDescription')?.hasError('invalidFile')">
        {{ groupSessionForm.get('detailedDescription')?.errors?.['message'] }}
      </mat-error>
    </mat-form-field>

    <!-- Display Existing Detailed Description File (SINGLE) -->
    <div class="col-12 mb-3" *ngIf="data?.detailedDescription">
      <h6>Existing Detailed Description File:</h6>
      <mat-chip-list>
        <mat-chip [removable]="true" (removed)="removeDetailedFile()">
          <a [href]="data.detailedDescription" target="_blank" class="text-decoration-none me-2">{{ extractFileName(data.detailedDescription) }}</a>
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      </mat-chip-list>
    </div>

    <!-- Presentation Files (MULTIPLE FILES) -->
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Presentation Files</mat-label>
      <ngx-mat-file-input
        placeholder="Select Files (Documents)"
        (change)="onPresentationFileChange($event)"
        multiple
        accept=".pdf,.doc,.docx,.ppt,.pptx,.txt">
      </ngx-mat-file-input>
      <mat-icon matSuffix>folder</mat-icon>
      <mat-hint>Max 25MB per file. Multiple documents allowed</mat-hint>
      <mat-error *ngIf="groupSessionForm.get('presentationUrls')?.hasError('invalidFile')">
        {{ groupSessionForm.get('presentationUrls')?.errors?.['message'] }}
      </mat-error>
    </mat-form-field>

    <!-- Display Existing Presentation Files (MULTIPLE) -->
    <div class="col-12 mb-3" *ngIf="data?.presentationUrls?.length">
      <h6>Existing Presentation Files:</h6>
      <mat-chip-list>
        <mat-chip *ngFor="let url of data.presentationUrls; let i = index" [removable]="true" (removed)="removePresentationFile(i)">
          <a [href]="url" target="_blank" class="text-decoration-none me-2">{{ extractFileName(url) }}</a>
          <mat-icon matChipRemove>cancel</mat-icon>
        </mat-chip>
      </mat-chip-list>
    </div>

    <!-- Description -->
    <div class="col-md-12 mb-3 mt-3">
      <mat-form-field appearance="outline" class="w-100">
        <mat-label>Description</mat-label>
        <textarea matInput maxlength="1000" rows="3" formControlName="description" placeholder="Enter description"></textarea>
        <mat-hint align="end">
          {{ suggestionsLength }} / 1000
        </mat-hint>
      </mat-form-field>
    </div>

    <!-- Submit Button -->
    <div class="col-12 justify-content-center d-flex gap-2">
      <button mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="primary" [disabled]="groupSessionForm.invalid || isLoading" (click)="submitForm()">
        {{ currentEditId ? 'Update' : 'Submit' }}
      </button>
    </div>

  </form>
  </mat-card>
</div>

<!-- Loader Spinner (only visible while loading) -->
<div class="spinner-container" *ngIf="isLoading">
  <mat-spinner diameter="60"></mat-spinner>
</div>
